import React, { createContext, useEffect, useState } from 'react';
import { ThemeProvider } from '@fnacdarty/back-office-ui';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import ErrorBoundary from '../components/generic/ErrorBoundary';
import { THEME } from '../config/theme';

export const AppContext = createContext();

export function AppProvider({ children }) {
	const [root, setRoot] = useState(null);
	const location = useLocation();
	const { pathname } = location;

	const isFullPage = (page) =>
		['/login', '/register', '/getting-started'].find((p) => p === page);

	const fullPage = isFullPage(pathname);

	useEffect(() => {
		const app = document.getElementById('root');
		if (app) {
			setRoot(app);
		}
	}, []);

	const context = {
		root,
		location,
		fullPage,
	};

	return (
		<ErrorBoundary>
			<AppContext.Provider value={context}>
				<ThemeProvider currentTheme={THEME}>{children}</ThemeProvider>
			</AppContext.Provider>
		</ErrorBoundary>
	);
}

AppProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
